// style sheet used
import "./App.css";
import React, { Component } from "react";
// Components
import Header from "./Components/Header";
import Profile from "./Components/Profile";
import Shop from "./Components/Shop";
import NavMenu from "./Components/NavMenu";
import Homepage from "./Components/Homepage";

// react router dom imports
import { BrowserRouter, Routes, Route } from "react-router-dom";

// logged in variable
const loggedIn = true;

// Below Ive used the App component to pass routes to other pages within the app.
// The whole app is wrapped in a BrowserRouter and only the component that will be used as pages are wrapped inside Routes.
// The NavMenu and Header component are on top so they can be displayed on every page.
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <NavMenu />
        {/* passing the logged user as props */}
        <Header name="Jane" loggedIn={loggedIn} />
        {/* routes to the apps pages */}
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/shop" element={<Shop />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;

// Photos by <a href="https://unsplash.com/@jonathanborba?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Jonathan Borba</a> on <a href="https://unsplash.com/s/photos/food?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a>
